// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-range {
  --bar-height: 16px;
  --bar-border-radius: 34px;
  --knob-size: 17px;
  --pin-background: transparent;
  --bar-background: var(--ion-color-medium);
  padding-top: 36px;
}

ion-range::part(bar-active) {
  background: var(--ion-color-primary);
}

ion-range::part(bar) {
  background: var(--bar-background);
}

ion-range::part(knob) {
  background: var(--ion-color-primary-tint);
  outline: none;
  transform: scale(1);
}

ion-range::part(pin) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--ion-color-primary-medium-tint);
  color: var(--text-color-dark);
  border-radius: 50%;
  transform: scale(1.01);
  top: -40px;
  left: -3px;
  min-width: 40px;
  height: 40px;
}

.vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
}

.selfconsumption-active {
  --bar-background: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/edge/live/Controller/Ess/ParallelPeakShavingAndSelfConsumption/flat/flat.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yCAAA;EACA,iBAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAEA;EACI,iCAAA;AACJ;;AAEA;EACI,yCAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,sDAAA;EAEA,6BAAA;EAEA,kBAAA;EACA,sBAAA;EAEA,UAAA;EACA,UAAA;EAEA,eAAA;EACA,YAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAJJ;;AAOA;EACI,0CAAA;AAJJ","sourcesContent":["ion-range {\n    --bar-height: 16px;\n    --bar-border-radius: 34px;\n    --knob-size: 17px;\n    --pin-background: transparent;\n    --bar-background: var(--ion-color-medium);\n    padding-top: 36px;\n}\n\nion-range::part(bar-active) {\n    background: var(--ion-color-primary);\n}\n\nion-range::part(bar) {\n    background: var(--bar-background);\n}\n\nion-range::part(knob) {\n    background: var(--ion-color-primary-tint);\n    outline: none;\n    transform: scale(1);\n}\n\nion-range::part(pin) {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    border: 2px solid var(--ion-color-primary-medium-tint);\n\n    color: var(--text-color-dark);\n\n    border-radius: 50%;\n    transform: scale(1.01);\n\n    top: -40px;\n    left: -3px; // Left offset needed because setting a width moves the pin off center\n\n    min-width: 40px;\n    height: 40px;\n}\n\n.vertical {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 16px;\n}\n\n.selfconsumption-active {\n    --bar-background: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
